export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/makeIconGreen.01d477f6.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};